import { WOW } from "wowjs";
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
// mixin主
export const mixin = {
	data(){
	    return {
	        wowInstance:'',
			// 上传
			uplink:'https://appapi.binli-logistics.com/app/storage/upload',
			// 默认图片
			imgDef1:'https://file.binli-logistics.com/static/icon70.png',
			imgDef2:'https://binli-logistics.oss-cn-guangzhou.aliyuncs.com/ylf9x92c6qmh1oyjsyzs.jpg',
	    }
	},
	computed: {
		...mapState('userMsg',['userInfo','token']),
	},
    methods:{
		// 提示
		Tips(message,type = 'success'){
			this.$message({
				showClose: true,
				message,
				type
			});
		},
		// 路由跳转
		link(url,query={}){
			this.$router.push({path:url,query});
		},
		// 返回
		back(){
			this.$router.back()
		},
		// 复制文字
		copy_txt(text) {
			if (navigator.clipboard) {
				navigator.clipboard.writeText(text).then(() => {
					this.$message.success('复制成功')
				})
			} else {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success('复制成功')
			}
		},
		// 下载图片
		downloadImage() {
			const link = document.createElement('a');
			link.download = 'poster.png';
			link.href = this.posterUrl;
			link.click();
		},
    },
    //挂载完毕就执行
    mounted() {
        var options = {
			boxClass:'wow',// default 在用户滚动时显示隐藏框的类名。
			animateClass:'animated',// default 触发 CSS 动画的类名（默认情况下，animmate.css 库为“animated”）
			offset:0,// default 定义浏览器视口底部与隐藏框顶部之间的距离。当用户滚动并达到此距离时，将显示隐藏框。
			mobile:true,// default 在移动设备上打开/关闭 wow.js。
			live:true,// default 持续检查页面上是否有新的 WOW 元素。
        };
        this.wowInstance = new WOW(options).init();
    },
}
// mixin次
export const shareData = {
    data(){
        return {
            x:10,
            y:20
        }
    }
}
